<div class="min-h-screen xl:flex">
  <div>
    <app-sidebar />
    <app-backdrop />
  </div>
  <!-- min-w-0: sin él, en xl el flex-1 no se achica por debajo de su contenido
       y una tabla ancha estira la página en vez de scrollear en su recuadro. -->
  <div
    class="flex min-h-screen min-w-0 flex-1 flex-col transition-all duration-300 ease-in-out"
    [ngClass]="{
        'xl:ml-[290px]': isExpanded$ | async,
        'xl:ml-[90px]': !(isExpanded$ | async),
        'ml-0': (isMobileOpen$ | async)
      }"
  >
    <!-- app header start -->
    <app-header />
    <!-- app header end -->
    <div class="w-full p-4 mx-auto max-w-(--breakpoint-2xl) md:p-6" [style.max-width]="isFullWidthPage ? 'none' : null">
      <router-outlet />
    </div>
    <app-footer />
  </div>
</div>
